var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AlfatronDspBase } from './util/AlfatronDspBase';
export class AlfatronDspUdp extends AlfatronDspBase {
    // other class properties and constructor
    constructor(socket, state, log, framework) {
        super(AlfatronDspUdp.driverType, state, log, framework);
        this.socket = socket;
    }
    send(command, match, tags, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.socket.send(command, match, tags, options);
            return resp.match;
        });
    }
}
// static properties
AlfatronDspUdp.driverType = 'udpDriver';
AlfatronDspUdp.key = '-NhbAFB0oouVRbyJQr0c';
AlfatronDspUdp.channelsConfigName = 'alfatronDsp88ControlChannels';
AlfatronDspUdp.socketOptions = (config) => {
    return [
        {
            isBinary: true,
            port: 50000,
        },
    ];
};
